qw-room-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  font-family: var(--qw-hotel-font-family);
  width: 100%;
  position: relative;
}

qw-room-list.is-filtering .qw-room-list__cards {
  animation: filtering 0.8s ease forwards;
}

@keyframes filtering {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

qw-room-list .qw-room-list__cards {
  opacity: 0;
}

qw-room-list.visualize-list .qw-room-list__cards {
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0.2s;
  /* animation: fadeIn 0.6s cubic-bezier(0, 0.55, 0.45, 1) forwards; */
}

/* Avoid bug that with tranform limit pop up view */

@keyframes fadeIn {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0px);
  }
}

qw-room-list .qw-loader {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  pointer-events: none;
  z-index: 2000;
}

qw-room-list.loading-skeleton qw-room-list-card {
  position: relative;
}

qw-room-list.loading-skeleton qw-room-list-card:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 200% 100%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-room-list.loading-skeleton qw-room-list-card h2 {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  background-size: 0%;
  border-radius: 2px;
  max-height: 30px;
  overflow: hidden;
}

qw-room-list.loading-skeleton .qw-room-base-item--container .icon {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0%;
  border-radius: 50%;
}

qw-room-list.loading-skeleton .qw-room-base-item--container p {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
}

qw-room-list.loading-skeleton qw-room-base-info + div {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
  border-radius: 2px;
}

qw-room-list.loading-skeleton qw-carousel.swiper-container:after {
  content: '';
  background-color: var(--qw-hotel-skeleton-medium);
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 101%;
  height: 101%;
  display: block;
}

qw-room-list.loading-skeleton .qw-room-rates__label,
qw-room-list.loading-skeleton
  .qw-room-rate__selector-wrapper
  .qw-room-rate__title,
qw-room-list.loading-skeleton .qw-room-rate__selector-wrapper .selected-rate,
qw-room-list.loading-skeleton
  .qw-room-rate__counter-add-to-basket
  .qw-room-rate__action-content
  .qw-select__occupancy
  + .qw-room-rate__price {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
  display: inline-block;
}

qw-room-list.loading-skeleton
  .qw-room-rate__selector-wrapper
  .selected-rate
  .selected-rate__reset {
  background: none;
}

qw-room-list.loading-skeleton .qw-room-rates__label {
  width: auto;
}

qw-room-list.loading-skeleton
  .qw-room-rate__counter-add-to-basket
  .qw-room-rate__counter-wrapper
  .qw-select__label,
qw-room-list.loading-skeleton .qw-room-rate__cancellation-policy--trigger,
qw-room-list.loading-skeleton .on-site-taxes {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
  background-size: 0;
}

qw-room-list.loading-skeleton .qw-room-rate__counter-add-to-basket .qw-button,
qw-room-list.loading-skeleton
  .qw-room-rate__counter-add-to-basket
  .qw-button
  .qw-button__cta {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  background-size: 0;
}

qw-room-list.loading-skeleton .qw-room-list-card__carousel {
  background-color: var(--qw-hotel-skeleton-dark);
}
qw-room-list.loading-skeleton .qw-room-list-card__carousel qw-image {
  opacity: 0;
}

qw-room-list.loading-skeleton
  .qw-room-rate__counter-add-to-basket
  .qw-button
  .qw-button__cta:after {
  background-size: 0;
}

qw-room-list.loading-skeleton
  .qw-room-rate__counter-add-to-basket
  .qw-room-rate__counter-wrapper
  select {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
  border-color: var(--qw-hotel-skeleton-medium);
}

qw-room-list.loading-skeleton
  qw-room-list-card
  qw-card
  .qw-card__rate
  .qw-room-rate--first
  .qw-room-rate__title {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
}

qw-room-list.loading-skeleton .qw-room-rate__selector {
  display: none;
}

.qw-room-list__cards {
  width: 100%;
}

.qw-room-list__card-wrapper {
  margin: 0 0;
  width: 100%;
}

.qw-room-list--grid .qw-room-list__card-wrapper {
  width: 49%;
}

.qw-room-list--grid .qw-room-list__cards {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
}

.qw-room-list__no-availability {
  margin: var(--qw-hotel-gap-md) 0;
}

qw-room-list qw-image {
  min-height: 200px;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.qw-room-list__filter-active {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 var(--qw-hotel-gap-lg);
}

.qw-room-list__filter-active .qw-room-list__filter-name {
  background-color: var(--qw-hotel-neutral-light);
  height: 35px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 0 var(--qw-hotel-gap-lg);
  margin-left: var(--qw-hotel-gap-lg);
  cursor: pointer;
}

.qw-room-list__filter-active .qw-room-list__filter-remove {
  background: url('https://hotels-booking-engine.qwentes.it/versions/v1/img/icons/close.svg')
    no-repeat center;
  background-size: 20px;
  height: 10px;
  width: 10px;
  display: block;
  margin-left: var(--qw-hotel-gap-xl);
}

@media only screen and (max-width: 738px) {
  .qw-room-list__card-wrapper qw-room-list-card {
    margin-bottom: 48px;
  }
}
